var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('timeline',{ref:"timeline",attrs:{"items":_vm.timeline.items,"groups":_vm.timeline.groups,"options":_vm.timeline.options},on:{"click":_vm.clicked}}),_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.stepMessage)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }